var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.LfBlueTitleComponent, { attrs: { title: _setup.TEXT.title } }),
      _c(_setup.LfSimpleProgressBarComponent, {
        attrs: { text: _setup.TEXT.caption },
      }),
      _c("div", { staticClass: "note-text" }, [
        _vm._v(_vm._s(_setup.TEXT.note)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }